export enum SigninButtonProvider {
  Google = 'google',
  Apple = 'apple',
}
